import React from 'react'
import PersonalColumn from '../Review/PersonalColumn'
import './appReview.scss'
import IncomeColumn from '../Review/IncomeColumn'
import EducationColumn from '../Review/EducationColumn'
import ConstDeclaration from './ConstDeclaration'
function AppTab() {
  return (
    <div className='app-review'>
      <div className="sub-title application-desc ">Please check the details submitted during the application.</div>

      <PersonalColumn />
      <IncomeColumn/>
      <EducationColumn/>
      <ConstDeclaration/>
    </div>
  )
}

export default AppTab
